import { IEmployerState } from '../types';

export enum Employers {
  GET_EMPLOYERS_REQUEST = '@employers/GET_EMPLOYERS_REQUEST',
  GET_EMPLOYERS_SUCCESS = '@employers/GET_EMPLOYERS_SUCCESS',
  GET_EMPLOYERS_FAIL = '@employers/GET_EMPLOYERS_FAIL',

  GET_ACTION_REQUIRED_EMPLOYERS_REQUEST = '@employers/GET_ACTION_REQUIRED_EMPLOYERS_REQUEST',
  GET_ACTION_REQUIRED_EMPLOYERS_SUCCESS = '@employers/GET_ACTION_REQUIRED_EMPLOYERS_SUCCESS',
  GET_ACTION_REQUIRED_EMPLOYERS_FAIL = '@employers/GET_ACTION_REQUIRED_EMPLOYERS_FAIL',

  GET_EMPLOYER_SITES_REQUEST = '@employers/GET_EMPLOYER_SITES_REQUEST',
  GET_EMPLOYER_SITES_SUCCESS = '@employers/GET_EMPLOYER_SITES_SUCCESS',
  GET_EMPLOYER_SITES_FAIL = '@employers/GET_EMPLOYER_SITES_FAIL',
}

export interface IEmployerAction {
  type: Employers;
  payload?: Record<string, IEmployerState>;
  meta?: any;
}
